import React from "react";
import { PageRoute } from "@quest-finance/quest-fe-shared/dist/common/types/PageRoute";

const ApplicationDetails = React.lazy(
  () => import("../pages/ApplicationDetails")
);
const ApplicationList = React.lazy(() => import("../pages/ApplicationList"));
const QuickQuote = React.lazy(() => import("../pages/QuickQuote"));

const routes: PageRoute[] = [
  {
    name: "Quick Quote",
    path: "/application/quotes/quick-quote",
    exact: true,
    component: QuickQuote,
  },
  {
    name: "Application Details",
    path: "/application/applications/:applicationId/:tabName?",
    exact: true,
    component: ApplicationDetails,
  },
  {
    name: "Application List",
    path: "/application/applications",
    component: ApplicationList,
  },
];

export default routes;
